import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-archived-transaction-detail',
  templateUrl: './archived-transaction-detail.component.html',
  styleUrls: ['./archived-transaction-detail.component.css'],
  providers: [DiamondPayDataService]
})
export class ArchivedTransactionDetailComponent implements OnInit {

  private routeSubscription: Subscription;
  private transaction: any;

  constructor(private dataService:  DiamondPayDataService,
              private route:        ActivatedRoute,
              private router:       Router) { }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
        this.dataService
            .retrieveArchivedTransaction(params['id'])
            .subscribe((response:any[]) => this.transaction = response, error => console.log(error));
    });
  }

  public unarchive(transaction) {
      this.dataService.unarchiveTransaction(transaction).subscribe((response: any) => {
          this.router.navigateByUrl('/app/diamond-pay/archived-transactions');
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/archived-transaction-detail/archived-transaction-detail.component.ts